import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import Authorization from "../../pages/Authorization/Authorization";
import LoggedInLayout from "../../shared/components/LoggedInLayout";
import { RedirectAuthorization } from "../../shared/hoc";
import PageNotFound from "../../shared/Ui/PageNotFound/PageNotFound";
import PageErrorMessage from "../../shared/Ui/PageErrorMessage/PageErrorMessage";

import ProfileCard from "../../pages/ProfileCard/ProfileCard";
import PageViewer from "../../pages/MainScreen/PageViewer";
import PageEditorV2Page from "../../pages/PageEditorV2";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* <Route path="/authorization" element={<Authorization />} /> */}

      <Route
        path="/"
        element={
          // <RedirectAuthorization>
            <LoggedInLayout />
          // </RedirectAuthorization>
        }
      >
        {/* <Route index element={<MainScreen />} />
        <Route path="main" element={<MainScreen />} /> */}
        <Route path="page-editor" element={<PageEditorV2Page />} />
        <Route path="page-editor/:id" element={<PageEditorV2Page />} />
        <Route path="page/:id" element={<PageViewer />} />
        <Route
          path="/error"
          element={<PageErrorMessage />}
        />
        <Route path="profile" element={<ProfileCard />} />
        <Route path="*" element={<PageNotFound />} />

      </Route >

      <Route path="/error" element={<PageErrorMessage />} />
      <Route path="*" element={<PageNotFound />} />
    </>,
  ),
);